module.exports = __webpack_public_path__ + "media/img/payment-methods/discover-e556ec0fd668d7721296de87a70c81a9.svg";